import { client } from '../apollo/client';
import {
  GET_CME_EVENTS_RECORD,
  GET_E_DRUG_EVENTS_RECORD,
  GET_HKDU_EVENTS_RECORD,
} from '../apollo/graphql/events';

const EVENT_QUERY_MAP = {
  cme_events: GET_CME_EVENTS_RECORD,
  e_drug_events: GET_E_DRUG_EVENTS_RECORD,
  hkdu_events: GET_HKDU_EVENTS_RECORD,
};

export const updateEventQuery = (eventType, eventId, doctorId) => () =>
  client.query({
    query: EVENT_QUERY_MAP[eventType],
    variables: { id: eventId, doctor_id: doctorId },
    fetchPolicy: 'network-only',
  });
